var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"fab":"","dark":"","large":_vm.large,"small":!_vm.large,"color":_vm.colour,"depressed":_vm.status,"outlined":_vm.outlined},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v(_vm._s(_vm.side))])}
var staticRenderFns = []

export { render, staticRenderFns }